<template>
  <v-form @submit.prevent ref="form" v-model="valid">
    <message-form :doc="doc" />
    <v-btn class="mt-5" color="amber" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import MessageForm from "./FourCornersForm";
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");

export default {
  name: "FourCornersFormAdd",
  components: {
    MessageForm,
  },
  data() {
    return {
      valid: true,
      doc: {},
    };
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      let ref = fb.competitionContentCollection.doc();
      ref
        .set({
          createdOn: new Date(),
          id: ref.id,
          title: this.populateField(this.doc.title),
          what: this.populateField(this.doc.what),
          learn: this.populateField(this.doc.learn),
          difference: this.populateField(this.doc.difference),
        })
        .then(() => {
          this.$emit("complete");
        })
        .catch((error) => {
          alert("Error adding document: ", error);
        });
    },
    populateField(field) {
      return field ? field : null;
    },
    validate() {
      this.$refs.form.validate();
    },
  },
};
</script>
